module.exports = __webpack_public_path__ + "media/images/info-icon-176cb581efba1e6fd7e115327439f0c1.png";